"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.64,4.37A2.55,2.55,0,0,1,24,5.68v9.43a2.38,2.38,0,0,1-1.28,2.17A2.38,2.38,0,0,0,24,15.11V5.68A2.55,2.55,0,0,0,23.64,4.37Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.9,17.47h0Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.57,19.87a2.27,2.27,0,0,1-.68-4.44c0-.11,0-.21,0-.32V8.27H1.13A1.13,1.13,0,0,0,0,9.4V19.54a1.13,1.13,0,0,0,1.13,1.13h17.7A1.13,1.13,0,0,0,20,19.54V18.46H8A15.11,15.11,0,0,1,3.9,19.85Z",
    fill: "#054966"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.64,18.12a1.08,1.08,0,0,0,.39.4A1.08,1.08,0,0,1,2.64,18.12Z",
    fill: "#054966"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3,18.52a1.07,1.07,0,0,0,.55.15h0A1.07,1.07,0,0,1,3,18.52Z",
    fill: "#054966"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.51,8.73l.07.12Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.83,8.28l.16,0Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.63,8.26h.18Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.38,8.58l.08.09Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.23,8.45l.1.07Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.06,8.35l.11.06Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3,11.34l-.17,0Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.08,11.26,10,11.21Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.51,11.36h-.18Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.46,10.52a1.08,1.08,0,0,1,0-.22A1.08,1.08,0,0,0,9.46,10.52Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.52,10.72a1.07,1.07,0,0,1-.07-.19A1.07,1.07,0,0,0,9.52,10.72Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.75,11l-.08-.09Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.62,10.89l-.07-.12Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.9,11.16l-.1-.07Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.76,13.88a1.07,1.07,0,0,0,.73.29l.21,0-.21,0A1.07,1.07,0,0,1,14.76,13.88Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.54,12.86l-.87-3.77a1.08,1.08,0,0,0-.07-.19,1.07,1.07,0,0,1,.07.19Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,15.11V5.68a2.55,2.55,0,0,0-.36-1.32,2.3,2.3,0,0,0-.4-.5,2.11,2.11,0,0,0-.33-.25,2,2,0,0,0-.38-.18,1.88,1.88,0,0,0-.62-.11H6a2.24,2.24,0,0,0-2.1,2.36v9.43s0,.05,0,.08a14.9,14.9,0,0,0,5.39-3A2.27,2.27,0,0,1,10,8.07l4.12-.95a2.27,2.27,0,0,1,2.72,1.7l.87,3.77a2.27,2.27,0,0,1-4.1,1.78,20.47,20.47,0,0,1-3.82,3.1H22.12l.12,0,.09,0,.13,0,.07,0,.14-.06.06,0A2.38,2.38,0,0,0,24,15.11Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "14.39 8.29 14.39 8.29 10.27 9.23 14.39 8.29 14.39 8.29",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.9,3.33h0a1.88,1.88,0,0,1,.62.11A1.88,1.88,0,0,0,21.9,3.33Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.54,12.86l-.87-3.77a1.07,1.07,0,0,0-.07-.19l0-.06-.07-.12,0-.06-.08-.09-.06-.05-.1-.07-.06,0-.11-.06-.06,0-.16,0h-.22l-.23,0h0l-4.12.95a1.07,1.07,0,0,0-.74,1.48l0,.06.07.12,0,.06.08.09.06.05.1.07.06,0,.11.06.06,0,.17,0h.22l.23,0L12.12,11a16.56,16.56,0,0,1-7.93,5.34,7.48,7.48,0,0,1-.77.19l-.22.06a1.07,1.07,0,0,0,.37,2.08h.16a11.12,11.12,0,0,0,1.87-.49,16.66,16.66,0,0,0,1.71-.7A19.25,19.25,0,0,0,14.13,12l.32,1.38a1.09,1.09,0,0,0,1,.83l.21,0h0l.21-.07.18-.11a1.08,1.08,0,0,0,.42-1.11Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.14,11.29l-.06,0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.33,8.52l.06.05Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.32,11.34h0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.59,13.68a1.07,1.07,0,0,0,.17.2A1.07,1.07,0,0,1,14.59,13.68Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.39,8.29l.23,0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.47,8.67l0,.06Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10,11.21l-.06,0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.59,13.68a1.07,1.07,0,0,1-.14-.34A1.07,1.07,0,0,0,14.59,13.68Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.75,11.33l-.23,0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.58,8.84l0,.06Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.12,14a1.08,1.08,0,0,0,.28-.3A1.08,1.08,0,0,1,16.12,14Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.81,8.28h0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.17,8.41l.06,0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.43,10.31a1.07,1.07,0,0,1,0-.21A1.07,1.07,0,0,0,9.43,10.31Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.56,10.77l0-.06Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.71,14.15h0l.21-.07-.21.07Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.81,11.09,9.75,11Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15,8.33l.06,0Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.67,10.95l0-.06Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;